// extracted by mini-css-extract-plugin
export var legendIndicator = "_av-1";
export var legendRight = "_av-0";